<ps-ui-modal>
  <div psUiModalTitle></div>
  <ps-ui-modal-body>
    <div>
      <h4 *ngIf="quotaInfoModal.qualificationName">
        Quota Management - {{ quotaInfoModal.qualificationName }}
      </h4>
      <h4 *ngIf="quotaInfoModal.editedQuota">
        Quota Management - {{ quotaInfoModal.editedQuota }}
      </h4>
      <h4 *ngIf="quotaInfoModal.nestedObj">
        Quota Management - {{ quotaInfoModal.nestedObj }}
      </h4>
    </div>
    <div class="feasibility-header">
      <ps-ui-tab-group [tabAlignment]="'left'">
        <ps-ui-tab label="quota_metrics">
          <div class="content-background-info-tab" id="quota_metrics">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <table class="info_modal_table">
                  <tr>
                    <th class="text-center">
                      {{
                        surveyDetail.click_balancing === 1
                          ? 'Completes'
                          : 'Valid Clicks'
                      }}
                    </th>
                    <th class="text-center" *psUiHasRole="'operator'">
                      Supplier Currently Open
                    </th>
                    <th class="text-center">Last Start Date</th>
                    <th class="text-center">Last Complete Date</th>
                    <th class="text-center">Conversion</th>
                    <th class="text-center" *psUiHasRole="'buyer'">Max</th>
                  </tr>
                  <tr class="text-center">
                    <td>
                      {{
                        surveyDetail.click_balancing === 1
                          ? quotaInfoModal.achieved
                          : quotaInfoModal.buyer_valid_clks
                      }}
                    </td>
                    <td *psUiHasRole="'operator'">
                      {{ quotaInfoModal.sup_currently_open }}
                    </td>

                    <td>
                      {{
                        quotaInfoModal.last_start_date === ''
                          ? '-'
                          : (quotaInfoModal.last_start_date
                            | date : 'MM/dd/yyyy h:mma')
                      }}
                    </td>
                    <td>
                      {{
                        quotaInfoModal.last_complete_date === ''
                          ? '-'
                          : (quotaInfoModal.last_complete_date
                            | date : 'MM/dd/yyyy h:mma')
                      }}
                    </td>
                    <td>{{ supConversion(quotaInfoModal) }}</td>
                    <td *ngIf="buyer !== 'none'">
                      {{ quotaInfoModal.maximum }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </ps-ui-tab>
        <ps-ui-tab label="pricing" *ngIf="quotaInfoModal.qbpEnabled">
          <div class="content-background-info-tab" id="pricing">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12">
                <table class="info_modal_table table_wdth100">
                  <tr>
                    <th class="text-center">QBP</th>
                    <th class="text-center">Current Price</th>
                    <th class="text-center row" *ngIf="surveyDetail.price_reco">
                      <div class="col-md-12 div-icon">
                        PurePrice™
                        <div class="tooltip-visible">
                          <div class="fa fa-info-circle tootip-setting-info">
                            <p>
                              PurePrice™ is a machine learning process that
                              looks at your project on the whole and suggests
                              the most optimized price, based on the project and
                              audience parameters and historical experience.
                            </p>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr class="pencil_width pricing-row">
                    <td class="text-center min-wid-130">
                      <div class="div-icon">
                        <div class="hover-edit-trigger" title="click to edit">
                          <div
                            e2e-data="qbp-pricing-edit-pen"
                            class="hover-text-field div-icon"
                            *ngIf="!editStateModal"
                            (click)="toggle()"
                          >
                            {{ quotaInfoModal.currencySymbol
                            }}{{ quotaInfoModal.cpi }}
                            <div class="div-icon div-icon-margin-top">
                              <i class="fa fa-pencil"></i>
                            </div>
                          </div>
                          <input
                            e2e-data="qbp-pricing-input-box"
                            class="form-control input-price-reco"
                            type="inputText"
                            [(ngModel)]="cpi"
                            *ngIf="editStateModal"
                            (keypress)="numberOnly($event, true)"
                            psInputDecimalRestriction
                          />
                        </div>
                        <div
                          class="edit-button-group div-icon"
                          *ngIf="editStateModal"
                        >
                          <div
                            e2e-data="qbp-pricing-save-btn"
                            class="fa fa-check-circle-o div-icon div-icon-margin-top"
                            (click)="save()"
                          ></div>
                          <div
                            class="fa fa-times-circle-o div-icon div-icon-margin-top"
                            (click)="editStateModal = !editStateModal"
                          ></div>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ quotaInfoModal.currencySymbol
                      }}{{
                        quotaInfoModal.cpi || quotaInfoModal.cpi === 0
                          ? quotaInfoModal.cpi
                          : quotaInfoModal.acpi
                      }}
                    </td>
                    <td
                      *ngIf="surveyDetail.price_reco"
                      class="text-center price-reco"
                    >
                      {{ quotaInfoModal.priceRecommendCpi }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td>
                      <div
                        class="col-md-12 div-icon"
                        *ngIf="surveyDetail.price_reco"
                      >
                        <button
                          psUiButton
                          (click)="updateQuotaCpi()"
                          class="apply-button"
                        >
                          APPLY
                        </button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </ps-ui-tab>
      </ps-ui-tab-group>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer position="center">
    <div class="row-qbp-footer-note" *ngIf="quotaInfoModal.qbpEnabled">
      Quota Based Pricing
      <span>{{ quotaInfoModal.childSurveyId ? 'ACTIVE' : 'INACTIVE' }}</span>
    </div>
  </ps-ui-modal-footer>
</ps-ui-modal>
